export default __webpack_public_path__ + "static/media/012-insurance.0dffc486.png";